import { Grid } from '@mui/material';

import { graphql, type DocumentType } from '@/gql';

import { AssistantAiResponseFeedbackLikeButton } from './feedback/AssistantAiResponseFeedbackLikeButton';

import { AssistantAiResponseFeedbackDislikeButton } from './feedback/AssistantAiResponseFeedbackDislikeButton';
import { AssistantAiResponseCopyButton } from './AssistantAIResponseCopyButton';

const ASSISTANT_AI_RESPONSE_FEEDBACK_ITEM_FRAGMENT = graphql(`
  fragment assistantAiResponseFeedbackItemFields on OrtooGptConversationItem {
    ...assistantAiResponseFeedbackLikeButtonItemFields
    ...assistantAiResponseFeedbackDislikeButtonItemFields
    ...assistantAiResponseFeedbackCopyItemFields
  }
`);

interface Props {
  item: DocumentType<typeof ASSISTANT_AI_RESPONSE_FEEDBACK_ITEM_FRAGMENT>;
}

export const AssistantAiResponseActions = ({ item }: Props) => {
  return (
    <Grid container direction="column">
      <Grid container spacing={1}>
        <Grid>
          <AssistantAiResponseFeedbackLikeButton item={item} />
        </Grid>
        <Grid>
          <AssistantAiResponseFeedbackDislikeButton item={item} />
        </Grid>
        <Grid>
          <AssistantAiResponseCopyButton item={item} />
        </Grid>
      </Grid>
    </Grid>
  );
};
